export interface PageLayoutConfig {
  enabled?: boolean;
  topHtml?: string;
  bottomHtml?: string;
  customCss?: string;
  showBreadcrumbs?: boolean;
  containerWidth?: "default" | "wide" | "full";
}

export type PageLayoutsMap = Record<string, PageLayoutConfig>;

export const PAGE_IDS = [
  "home",
  "shop",
  "category",
  "product",
  "blog",
  "blogPost",
  "static",
  "cart",
  "checkout",
  "account",
  "auctions",
  "wishlist",
  "compare",
  "newArrivals",
  "offer",
  "brands",
  "categoriesList",
  "faq",
  "giftCertificates",
  "affiliate",
  "influencers",
  "contact",
  "about",
  "features",
  "orderTracking",
] as const;

export type PageId = (typeof PAGE_IDS)[number];

export function pageIdFromPath(pathname: string): PageId | null {
  if (pathname === "/" || pathname === "") return "home";
  if (pathname.startsWith("/shop")) {
    try {
      const u = new URL(pathname, "http://x");
      if (u.searchParams.get("category")) return "category";
    } catch {}
    return "shop";
  }
  if (pathname.startsWith("/product/")) return "product";
  if (pathname === "/blog" || pathname.startsWith("/blog?")) return "blog";
  if (pathname.startsWith("/blog/")) return "blogPost";
  if (pathname.startsWith("/page/")) return "static";
  if (pathname === "/cart" || pathname.startsWith("/cart?")) return "cart";
  if (pathname.startsWith("/checkout")) return "checkout";
  if (pathname.startsWith("/account")) return "account";
  if (pathname === "/auctions" || pathname.startsWith("/auctions?") || pathname.startsWith("/auctions/")) return "auctions";
  if (pathname === "/wishlist" || pathname.startsWith("/wishlist?")) return "wishlist";
  if (pathname === "/compare" || pathname.startsWith("/compare?")) return "compare";
  if (pathname === "/new-arrivals" || pathname.startsWith("/new-arrivals?")) return "newArrivals";
  if (pathname.startsWith("/offers/")) return "offer";
  if (pathname === "/brands" || pathname.startsWith("/brands?")) return "brands";
  if (pathname === "/categories" || pathname.startsWith("/categories?")) return "categoriesList";
  if (pathname === "/faq" || pathname.startsWith("/faq?")) return "faq";
  if (pathname === "/gift-certificates" || pathname.startsWith("/gift-certificates")) return "giftCertificates";
  if (pathname === "/affiliate-program" || pathname.startsWith("/affiliate-program")) return "affiliate";
  if (pathname === "/influencers" || pathname.startsWith("/influencers")) return "influencers";
  if (pathname === "/contact" || pathname.startsWith("/contact")) return "contact";
  if (pathname === "/about" || pathname.startsWith("/about")) return "about";
  if (pathname === "/features" || pathname.startsWith("/features")) return "features";
  if (pathname === "/order-tracking" || pathname.startsWith("/order-tracking")) return "orderTracking";
  return null;
}

export const PAGE_LABELS_AR: Record<PageId, string> = {
  home: "الصفحة الرئيسية",
  shop: "صفحة المتجر",
  category: "صفحة القسم",
  product: "صفحة المنتج",
  blog: "صفحة المدونة",
  blogPost: "صفحة مقال المدونة",
  static: "الصفحات الثابتة",
  cart: "صفحة السلة",
  checkout: "صفحة الدفع",
  account: "صفحة الحساب",
  auctions: "صفحة المزادات",
  wishlist: "صفحة المفضلة",
  compare: "صفحة المقارنة",
  newArrivals: "صفحة الوصل حديثاً",
  offer: "صفحة العروض",
  brands: "صفحة الماركات",
  categoriesList: "صفحة قائمة الأقسام",
  faq: "صفحة الأسئلة الشائعة",
  giftCertificates: "صفحة بطاقات الهدايا",
  affiliate: "صفحة برنامج التسويق بالعمولة",
  influencers: "صفحة المؤثرين",
  contact: "صفحة تواصل معنا",
  about: "صفحة من نحن",
  features: "صفحة المميزات",
  orderTracking: "صفحة تتبع الطلب",
};

export const PAGE_LABELS_EN: Record<PageId, string> = {
  home: "Homepage",
  shop: "Shop Page",
  category: "Category Page",
  product: "Product Page",
  blog: "Blog Page",
  blogPost: "Blog Post Page",
  static: "Static Pages",
  cart: "Cart Page",
  checkout: "Checkout Page",
  account: "Account Page",
  auctions: "Auctions Page",
  wishlist: "Wishlist Page",
  compare: "Compare Page",
  newArrivals: "New Arrivals Page",
  offer: "Offers Page",
  brands: "Brands Page",
  categoriesList: "Categories Listing Page",
  faq: "FAQ Page",
  giftCertificates: "Gift Certificates Page",
  affiliate: "Affiliate Program Page",
  influencers: "Influencers Page",
  contact: "Contact Page",
  about: "About Page",
  features: "Features Page",
  orderTracking: "Order Tracking Page",
};
